import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "src/components/pages/landing/landingPage";
import TemplatesPage from "src/components/pages/templates/templatesPage";
import { useAppDispatch } from "src/store/store";
import { getAllInspectionTemplates } from "src/store/inspectionTemplateSlice";
import { getInspectionsByUser } from "src/store/inspectionSlice";
import QuestionsPage from "./pages/questions/questionsPage";
import AdminLayout from "./pages/admin/adminLayout";
import RequireAdmin from "./pages/admin/requireAdmin";
import CompletedInspections from "./pages/inspection/completedInspections";
import InspectionRouter from "./pages/inspection/inspectionRouter";
import ConfigurationDrivenInspections from "./pages/configurationDrivenInspections/configurationDrivenInspections";
import WorkflowExecutor from "./pages/configurationDrivenInspections/WorkflowExecutor";
import CheckpointsPage from "./pages/configurationDrivenInspections/CheckpointsPage";
import InspectionReviewPage from "./pages/configurationDrivenInspections/inspectionReview/InspectionReviewPage";
import OverrideCompliancePage from "./pages/configurationDrivenInspections/inspectionReview/OverrideCompliancePage";
import ScannerPage from "./pages/classification/ScannerPage";
import ResultsPage from "./pages/classification/ResultsPage";
import AIResearchResultsPage from "./pages/classification/AIResearchResultsPage";

const AuthorizedContent = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getAllInspectionTemplates());
    dispatch(getInspectionsByUser());
  }, []);
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" />} />
      <Route path="/home" element={<LandingPage />} />
      <Route
        path="/admin/*"
        element={
          <RequireAdmin>
            <AdminLayout />
          </RequireAdmin>
        }
      />
      <Route path="/templates" element={<TemplatesPage />} />
      <Route path="/templates/:templateId" element={<QuestionsPage />} />
      <Route path="/completedInspections" element={<CompletedInspections />} />
      <Route path="/inspections/:inspectionId" element={<InspectionRouter />} />
      <Route path="/configurationDrivenInspections" element={<ConfigurationDrivenInspections />} />
      <Route path="/configurationDrivenInspections/workflows/:workflowTemplateId/checkpoints" element={<CheckpointsPage />} />
      <Route path="/configurationDrivenInspections/execute" element={<WorkflowExecutor />} />
      <Route path="/configurationDrivenInspections/:inspectionId/review" element={<InspectionReviewPage />} />
      <Route path="/configurationDrivenInspections/:inspectionId/override" element={<OverrideCompliancePage />} />
      <Route path="/classification/scan" element={<ScannerPage />} />
      <Route path="/classification/results" element={<ResultsPage />} />
      <Route path="/classification/aiResults" element={<AIResearchResultsPage />} />
    </Routes>
  );
};

export default AuthorizedContent;
